import { Card as AntdCard } from "@empglabs/backoffice-ui-kit"

const Card = props => {
  return <AntdCard {...props} />
}

export default Card
